import http from "../../axios-config/g-http-metodos";

function GetTituloByFiltro(filtros) {
    const{res, erro, requisicao} = http.postArray('/Documento/GetTituloByFiltro', filtros)
    return{ DocumentoArray: res, erro , requisicao}
}

function GetPedidoByDocumentoId(DocumentoId) {
    const{res, erro, requisicao} = http.get(`/Documento/GetPedidoByDocumentoId/${DocumentoId}`)
    return{ DocumentoArray: res, erro , requisicao}
}

const DocumentoController = {
    GetPedidoByDocumentoId,
    GetTituloByFiltro
}

export default DocumentoController
